import React from 'react'
import { useTheme } from '../hooks/useTheme'
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline'

/**
 * ThemeToggle Component - Toggle to switch between light and dark mode
 * 
 * This component displays a button with icons that allows users
 * to toggle between light and dark mode.
 * State is persisted in localStorage and synchronized with Redux.
 */
const ThemeToggle = () => {
  const { theme, isDarkMode, toggle } = useTheme()

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={toggle}
        className="btn btn-ghost btn-sm gap-2 text-white hover:bg-primary-700 transition-colors"
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDarkMode ? (
          <>
            <SunIcon className="h-5 w-5" />
            <span className="hidden sm:inline">Light Mode</span>
          </>
        ) : (
          <>
            <MoonIcon className="h-5 w-5" />
            <span className="hidden sm:inline">Dark Mode</span>
          </>
        )}
      </button>
    </div>
  )
}

export default ThemeToggle

